import { render, staticRenderFns } from "./adm.vue?vue&type=template&id=05bd3768&scoped=true"
import script from "./adm.vue?vue&type=script&lang=js"
export * from "./adm.vue?vue&type=script&lang=js"
import style0 from "./adm.vue?vue&type=style&index=0&id=05bd3768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd3768",
  null
  
)

export default component.exports